import { i18n } from "@/plugins/i18n";

export const getTranslationMixin = {
  methods: {
    getLabelTranslation(item) {
      if (
        item.labelTranslations &&
        item.labelTranslations.hasOwnProperty(i18n.locale)
      ) {
        return item.labelTranslations[i18n.locale];
      }
      return item.label;
    },
    getTextTranslation(tekstueleInformatie) {
      if (
        tekstueleInformatie.textTranslations &&
        tekstueleInformatie.textTranslations.hasOwnProperty(i18n.locale)
      ) {
        return tekstueleInformatie.textTranslations[i18n.locale];
      }

      return tekstueleInformatie.text;
    },
    getOmschrijvingTranslation(item) {
      if (item.vertalingen && item.vertalingen.hasOwnProperty(i18n.locale)) {
        return item.vertalingen[i18n.locale];
      }

      return item.omschrijving;
    },
    getEenheidTranslation(item) {
      if (
        item.eenheidVertalingen &&
        item.eenheidVertalingen.hasOwnProperty(i18n.locale)
      ) {
        return item.eenheidVertalingen[i18n.locale];
      }

      return item.eenheidOmschrijving;
    }
  }
};
